module.exports = __webpack_public_path__ + "static/media/nrna3.a53c36ce.png";